import { store } from '../../index';
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import useMediaQuery from '@mui/material/useMediaQuery';
import useIsDesktop from '../../hooks/useIsDesktop';
import { useRef } from "react";
import {
  Button,
  Card,
  Grid,
  Hidden,
  Typography,
  Divider,
  Box,
  Fab,
  Popper,
  Paper,
  ClickAwayListener,
  List,
  ListItem,
  ListItemText,
  Backdrop,
} from "@material-ui/core";
import defaultimg from "../../assets/images/default.png";
import VegIcon from "../../assets/images/Veg Icon 1.svg";
import NonVegIcon from "../../assets/images/Non Veg Icon 1.svg";
import ItemModifier from "../../components/Modifier";
import Repeatation from "../../components/Repeatation";
import ListAddItemButton from "../../components/ListAddItemButton";
import {
  MENU_HEADER_COLOR,
  TEXT_COLOR,
  BACKGROUND_COLOR,
  BUTTON_COLOR,
  STORE_DETAILS,
  TOKEN_KEY,
} from "../../utils/constant";
import { get_inventory } from "../../utils/item_helper";
import RestaurantMenuIcon from "@mui/icons-material/RestaurantMenu";
import { fontSize, width } from "@mui/system";
import ClearIcon from "@mui/icons-material/Clear";
import fssaiimage from "../../assets/images/fssai-logo-df4c.png";
import CyntraLogo from "../../assets/images/cyntra_logo.svg";
import TuneIcon from "@mui/icons-material/Tune";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

// Desktop frame helper – pins fixed elements to the 814px centered frame
const FRAME_WIDTH = 814;
const getFabRight = () => {
  if (window.innerWidth >= 768) {
    // right edge of frame = calc(50% - 407px), so FAB should be 20px inside that
    return `calc(50% - ${FRAME_WIDTH / 2}px + 20px)`;
  }
  return "20px";
};

const Items = function (props) {
  const isDesktop = useIsDesktop();
  const sessionReducer = useSelector(state => state.sessionReducer) || {};
  const {
    selectedCategoryName,
    itemList,
    allitem,
    itemVerriantList,
    addonList,
    currency,
    storeInfo,
    storeInfoConfig,
    categoriesData,
    allCategoryList,
    cartProps,
    selectedfilter,
    appliedfilters,
  } = props;
  const { addedItems } = cartProps;

  const getFabBottom = () => {
    const customer = props?.customerReducer?.customer;
    const isLoggedIn = customer?.cust_mobile && customer?.guest !== "Guest";
    const getFSRStatus = () => {
      return sessionReducer.is_fsr === true;
    };

    // If not logged in, action tray is hidden, so there are no active orders
    if (!isLoggedIn) {
      const isCartNotEmpty = addedItems.length > 0;
      const baseBottom = isCartNotEmpty ? 78 : 20;
      const isTableMgmt = getFSRStatus();
      if (isTableMgmt) {
        return `calc(${baseBottom + 64 + 12}px + env(safe-area-inset-bottom, 0px))`;
      }
      return `${baseBottom + 12}px`;
    }

    const last_order = props.reducer?.last_order;
    const associated_stores = props.sessionReducer?.associated_stores;
    const isMultiStore = storeInfoConfig?.web_ordering_setting?.is_multi_store_qr;

    const allowedStoreIds = new Set();
    if (isMultiStore && Array.isArray(associated_stores) && associated_stores.length > 0) {
      associated_stores.forEach(s => {
        if (s?.store_id) allowedStoreIds.add(String(s.store_id));
      });
    } else if (storeInfo?.store_id) {
      allowedStoreIds.add(String(storeInfo.store_id));
    }

    const isTableMgmt = getFSRStatus();

    const isOrderFromToday = (order) => {
      const rawDate = order?.business_date || order?.date_time || order?.created_at || "";
      const dateStr = rawDate.replace(" ", "T");
      const d = new Date(dateStr);
      if (isNaN(d.getTime())) return false;
      const orderDateOnly = dateStr.slice(0, 10);
      const businessDate = props.sessionReducer?.store_details?.business_date;
      if (businessDate) {
        return orderDateOnly === businessDate.slice(0, 10);
      }
      const today = new Date();
      return (
        d.getDate() === today.getDate() &&
        d.getMonth() === today.getMonth() &&
        d.getFullYear() === today.getFullYear()
      );
    };

    let activeOrders = last_order?.order_details?.filter(
      (order) => {
        const orderStoreId = String(order?.store_details?.store_id || order?.store_id || "");
        if (!allowedStoreIds.has(orderStoreId)) return false;

        const status = (order?.order_status || "").toUpperCase();
        const state = (order?.order_state || "").toUpperCase();

        if (status !== "OPEN" || state !== "PLACED") return false;
        if (!isOrderFromToday(order)) return false;

        return true;
      }
    ) || [];

    // Sort by date_time descending (latest first)
    activeOrders.sort((a, b) => new Date(b.date_time) - new Date(a.date_time));

    // Limit to the latest two orders
    activeOrders = activeOrders.slice(0, 2);

    const hasActiveOrders = activeOrders.length > 0;
    const isCartNotEmpty = addedItems.length > 0;

    let baseBottom = 20;
    if (hasActiveOrders) {
      const isMultiple = activeOrders.length > 1;
      if (isCartNotEmpty) {
        baseBottom = isMultiple ? 180 : 155;
      } else {
        baseBottom = isMultiple ? 108 : 92;
      }
    } else {
      baseBottom = isCartNotEmpty ? 78 : 20;
    }

    // Add 12px gap between FAB and whatever is above it (checkout bar / footer)
    const gap = 12;
    if (isTableMgmt) {
      // Footer is 64px + env(safe-area-inset-bottom) on iOS.
      return `calc(${baseBottom + 64 + gap}px + env(safe-area-inset-bottom, 0px))`;
    }
    return `${baseBottom + gap}px`;
  };

  const [modifierPopup, setModifierPopup] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [action, setAction] = React.useState(0);
  const [isRepeatation, setIsRepeatation] = useState(false);
  const [showDescription, setShowDescription] = useState({});
  const [inventoryData, setInventoryData] = useState([]);
  const filter = JSON.parse(localStorage.getItem("filter"));
  const [categoryMenuOpen, setCategoryMenuOpen] = useState(false);

  useEffect(() => {
    if (categoryMenuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [categoryMenuOpen]);
  const categoryMenuAnchorRef = useRef(null);
  const categoryRefs = useRef({});
  const storeDetails = JSON.parse(localStorage.getItem(STORE_DETAILS) || "{}");
  const storeFssai =
    storeDetails?.store_fssai ||
    storeDetails?.store?.store_fssai;

  const getCategoryName = (id) => {
    let categoryName = allCategoryList?.find(
      (e) => String(e.category_id) == String(id)
    );
    if (!categoryName) {
      console.log("DEBUG: getCategoryName - category not found for ID:", id);
      console.log("DEBUG: getCategoryName - allCategoryList count:", allCategoryList?.length);
    }
    return categoryName?.category_name || "Menu";
  };

  const getItemDisplayPrice = (item) => {
    const matchingCartItems = (addedItems || []).filter(
      (ci) => String(ci._id) === String(item._id) && !ci.is_void && !ci.isVoid && !ci.is_refund
    );
    if (matchingCartItems.length > 0) {
      const latestCartItem = matchingCartItems[matchingCartItems.length - 1];
      const basePrice = parseFloat(latestCartItem?.item_variant?.[0]?.plu || 0);
      const addonsPrice = (latestCartItem?.selected_addons_items || []).reduce((sum, addon) => {
        return sum + parseFloat(addon?.item_variant?.[0]?.plu || 0);
      }, 0);
      return basePrice + addonsPrice;
    }
    const defaultVar = (item?.item_variant || []).find((v) => v.is_default) || item?.item_variant?.[0];
    return parseFloat(defaultVar?.plu || 0);
  };

  let menuStore = storeInfoConfig?.web_ordering_setting?.is_menu;

  let skipDescription =
    storeInfoConfig?.web_ordering_setting?.item_description_qr;

  let primaryColor = storeInfoConfig?.general_config?.primary_color;

  const paragraphRefs = useRef([]);

  const handleClick = (category_id) => {
    setShowDescription((prevState) => ({
      ...prevState,
      [category_id]: !prevState[category_id],
    }));
  };

  const selectedStyle = (index) => {
    return {
      whiteSpace: showDescription[index] ? "" : "nowrap",
    };
  };

  useEffect(() => {
    // Keep window layout fixed on top on item list change
  }, [itemList]);

  // First filter: items with valid price (including 0rs) and category_id
  let filterPriceItems = (itemList || [])?.filter(
    (e) => parseFloat(e?.item_variant?.[0]?.plu) >= 0 && e?.category_id !== ""
  );

  // Second filter: only keep items whose category exists in allCategoryList
  filterPriceItems = filterPriceItems?.filter((item) => {
    const categoryExists = allCategoryList?.some(
      (cat) => String(cat.category_id) === String(item.category_id)
    );
    if (!categoryExists) {
      console.log("DEBUG: Filtering out item - category not found:", {
        item_name: item.item_name,
        category_id: item.category_id
      });
    }
    return categoryExists;
  });

  console.log("DEBUG: Items.js - filterPriceItems count:", (filterPriceItems || []).length);

  const categoryMap =
    categoriesData?.reduce((acc, cat) => {
      acc[cat.category_id] = {
        name: cat.category_name,
        sequence: cat.cat_sequence_no,
      };
      return acc;
    }, {}) || {};
  const groupedItems = filterPriceItems?.reduce((acc, item) => {
    const categoryId = item?.category_id || "default"; // Use "default" for items without a category_id
    const categoryInfo = categoryMap[categoryId];
    const categoryName =
      categoryInfo?.name || (categoryId === "default" ? "Unknown Category" : ` ${categoryId}`);
    // console.log(allCategoryList);
    if (!acc[categoryId]) {
      acc[categoryId] = {
        categoryName: categoryName,
        categoryId: categoryId,
        items: [],
        sequence: categoryInfo?.sequence || item.cat_sequence_no || 999,
      };
    }
    acc[categoryId].items.push(item);
    return acc;
  }, {});
  const sortedCategories = Object.entries(groupedItems || {}).sort(
    ([, a], [, b]) => {
      return (a.sequence || 999) - (b.sequence || 999);
    }
  );

  const loadInventory = async () => {
    const inventory = await get_inventory();
    setInventoryData(inventory);
  };

  useEffect(() => {
    loadInventory();
  }, []);

  const checkInventory = (item) => {
    const sku = item?.sku;
    const inventory = inventoryData?.find((e) => e?.sku === sku);
    if (
      inventory?.inventory_quantity == null ||
      inventory?.inventory_quantity > 5
    ) {
      return false;
    }
    return true;
  };

  const handleCategoryClick = (categoryId) => {
    setCategoryMenuOpen(false);
    const categoryElement = categoryRefs.current[categoryId];
    if (categoryElement) {
      categoryElement.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    }
  };

  const handleCategoryMenuToggle = () => {
    setCategoryMenuOpen((prevOpen) => !prevOpen);
  };

  const handleCategoryMenuClose = (event) => {
    if (categoryMenuAnchorRef.current?.contains(event.target)) {
      return;
    }
    setCategoryMenuOpen(false);
  };

  const renderItemCard = (e, index) => {
    const matchingCartItems = addedItems?.filter((item) => item?._id === e?._id) || [];
    const specialRequests = matchingCartItems
      .map((item) => item.specialRequest)
      .filter((req) => req && req.trim() !== "");

    const hasCustomise = (e?.item_variant?.length > 1 ||
      (e?.item_variant?.[0]?.item_addons?.length > 0 &&
        !e?.item_variant[0].item_addons.includes(""))) && e?.is_stock;

    return (
      <div
        key={index}
        ref={(el) => (paragraphRefs.current[index] = el)}
        style={{
          padding: hasCustomise ? "20px 16px 52px 16px" : "20px 16px 36px 16px",
          borderBottom: "1px solid #F3F4F6",
          display: "flex",
          alignItems: "flex-start",
          gap: "16px",
        }}
      >
        <div style={{ flex: 1, minWidth: 0 }}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
              alignItems: "flex-start",
              marginBottom: "8px",
            }}
          >
            <Typography
              variant="h6"
              style={{
                fontWeight: "600",
                textAlign: "left",
                textTransform: "capitalize",
                fontSize: "17px",
                color: "#333",
                lineHeight: "1.3",
                margin: 0,
                marginBottom: "4px",
              }}
            >
              <span style={{ fontSize: "17px" }}>
                {e?.item_name?.toLowerCase() || ""}
              </span>
            </Typography>
            {e?.description && (
            <Typography
              style={{
                textAlign: "left",
                color: "#999999",
                overflow: "hidden",
                lineHeight: 0.9,
                paddingBottom: "0.5rem",
              }}
            >
              <span style={{ fontSize: "14px", fontWeight: "500" }}>
              {showDescription[e.item_name]
                ? e.description
                : e.description.length > 40
                  ? `${e.description.slice(0, 40)}...`
                  : e.description}

                {e.description.length > 40 && (
                  <span
                    style={{
                      color: primaryColor,
                      fontWeight: "600",
                      cursor: "pointer",
                      marginLeft: "2px",
                    }}
                    onClick={() => handleClick(e?.item_name)}
                  >
                    {showDescription[e.item_name] ? "less" : "more"}
                  </span>
                )}
              </span>
            </Typography>
            )}
            <Typography
              style={{
                fontWeight: "600",
                textAlign: "left",
                fontSize: "16px",
                color: primaryColor || "#333",
              }}
            >
               <span style={{ fontWeight: "600",fontSize: "18px" }}>{currency}{" "}</span>
                              <span style={{ fontSize: "18px" }}>
                {(() => {
                  const p = getItemDisplayPrice(e);
                  return p % 1 === 0 ? p.toFixed(0) : p.toFixed(2);
                })()}
              </span>
            </Typography>
          </div>
        </div>

        <div
          style={{
            width: "120px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            flexShrink: 0,
          }}
        >
          <div
            style={{
              position: "relative",
              width: "115px",
              height: "110px",
              borderRadius: "16px",
              backgroundColor: "#f5f5f5",
              overflow: "visible",
            }}
          >
            {(() => {
              const d = e?.dietary?.toLowerCase()?.trim();
              const isVeg = d === "veg";
              const isNonVegOrEgg = d === "non-veg" || d === "nonveg" || d === "non veg" || d === "non_veg" || d === "egg" || d === "eggetarian" || d === "eggiterian" || d === "eggitarian";
              if (!isVeg && !isNonVegOrEgg) return null;
              return (
                <img
                  src={isVeg ? VegIcon : NonVegIcon}
                  alt={e?.dietary}
                  style={{
                    position: "absolute",
                    top: "4px",
                    left: "4px",
                    width: "16px",
                    height: "16px",
                    objectFit: "contain",
                    zIndex: 2,
                  }}
                />
              );
            })()}
            <img
              alt="Food item"
              style={{
                borderRadius: "16px",
                height: "100%",
                width: "100%",
                objectFit: "cover",
              }}
              src={e?.item_display_img || defaultimg}
              onError={(ev) => {
                ev.target.onerror = null;
                ev.target.src = defaultimg;
              }}
            />

            <div
              style={{
                position: "absolute",
                top: "95%",
                left: "50%",
                display: (filter && filter?.menu_qr) || menuStore ? "none" : "",
                transform: "translate(-50%, -50%)",
                zIndex: 3,
              }}
            >
              <ListAddItemButton
                {...{
                  lineItem: e,
                  setSelectedItem,
                  setModifierPopup,
                  setIsRepeatation,
                  storeInfo,
                  storeInfoConfig,
                  setAction,
                  checkInventory: checkInventory(e),
                  isOutOfStock: !e?.is_stock,
                }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderDesktopItemCard = (e, index) => {
    const price = getItemDisplayPrice(e).toFixed(2);
    const isOutOfStock = !e?.is_stock;
    const hasCustomization = e?.item_variant?.length > 1 ||
      (e?.item_variant?.[0]?.item_addons?.length > 0 && !e?.item_variant[0].item_addons.includes(""));
    const description = e?.description || "";

    return (
      <Card
        key={index}
        style={{
          borderRadius: "7px",
          border: "1px solid #DDDDDD",
          boxShadow: "none",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          backgroundColor: "#fff",
          // cursor: "pointer",
          height: "100%",
          minHeight: "295px", // Allows card to expand when 'more' is clicked
        }}
      >
        {/* Image — padded with white background (70% card height) */}
        <div style={{
          width: "calc(100% - 8px)", // 100% minus margin (4px * 2)
          height: "200px",
          backgroundColor: "rgb(245, 245, 245)", // Gray background as requested
          overflow: "hidden",
          flexShrink: 0,
          position: "relative",
          margin: "4px auto 0", // 4px top margin, auto horizontal centering
          borderRadius: "4px", // Round the image corners
        }}>
          <img
            alt={e?.item_name}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain", // Use contain so the image is never cropped/cut
              objectPosition: "center", // Explicitly center the image
              // display: "block",
            }}
            src={e?.item_display_img || defaultimg}
            onError={(ev) => {
              ev.target.onerror = null;
              ev.target.src = defaultimg;
            }}
          />
        </div>

        {/* Card Content */}
        <div style={{ padding: "12px 12px 16px 12px", display: "flex", flexDirection: "column", flexGrow: 1 }}>

          {/* Name + dietary icon */}
          <div style={{ display: "flex", alignItems: "center", gap: "6px", marginBottom: "4px" }}>
            {(() => {
              const d = e?.dietary?.toLowerCase()?.trim();
              const isVeg = d === "veg";
              const isNonVegOrEgg = d === "non-veg" || d === "nonveg" || d === "non veg" || d === "non_veg" || d === "egg" || d === "eggetarian" || d === "eggiterian" || d === "eggitarian";
              if (!isVeg && !isNonVegOrEgg) return null;
              return (
                <img
                  src={isVeg ? VegIcon : NonVegIcon}
                  alt={e?.dietary}
                  style={{ width: "15px", height: "15px", flexShrink: 0 }}
                />
              );
            })()}
            <Typography style={{
              fontWeight: 700,
              fontSize: "17px",
              color: "#1a1a1a",
              lineHeight: 1.3,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}>
              {e?.item_name}
            </Typography>
          </div>

          {/* Description with more/less toggle */}
          {description ? (
            <Typography style={{
              fontSize: "14px",
              color: "#777",
              lineHeight: 1.45,
              marginBottom: "10px",
              textAlign: "left",
              minHeight: "38px", // Ensures minimum space for 2 lines
            }}>
              {showDescription[e.item_name]
                ? description
                : description.length > 75
                  ? `${description.slice(0, 75)}...`
                  : description}

              {description.length > 75 && (
                <span
                  style={{
                    color: primaryColor || BUTTON_COLOR,
                    fontWeight: 500,
                    cursor: "pointer",
                    marginLeft: "2px",
                  }}
                  onClick={(ev) => {
                    ev.stopPropagation(); // Prevent triggering card click
                    handleClick(e?.item_name);
                  }}
                >
                  {showDescription[e.item_name] ? "less" : "more"}
                </span>
              )}
            </Typography>
          ) : (
            <div style={{ marginBottom: "10px", minHeight: "38px" }} />
          )}

          {/* Price + Add button row */}
          <div style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginTop: "auto", // Push to bottom
            marginBottom: "14px", // Equal bottom padding below Customise text
          }}>
            <Typography style={{
              fontWeight: 700,
              fontSize: "20px",
              color: primaryColor || BUTTON_COLOR,
              flexShrink: 0,
            }}>
            <span style={{fontSize: "21px",fontWeight:600}}>{currency}</span> 
            &nbsp;
            {(() => {
              const p = parseFloat(price);
              return p % 1 === 0 ? p.toFixed(0) : p.toFixed(2);
            })()}

            </Typography>

            {!menuStore && (
              <div style={{ minWidth: "90px", display: "flex", flexDirection: "column", alignItems: "flex-end", position: "relative" }}>
                <ListAddItemButton
                  {...{
                    lineItem: e,
                    setSelectedItem,
                    setModifierPopup,
                    setIsRepeatation,
                    storeInfo,
                    storeInfoConfig,
                    setAction,
                    checkInventory: checkInventory(e),
                    isOutOfStock: isOutOfStock,
                    isDesktop: true,
                  }}
                />
              </div>
            )}
          </div>
        </div>
      </Card>
    );
  };



  const getDesktopItems = () => {
    let desktopItemList = props.itemList || [];
    const cat = props.selectedCategory;
    if (cat && cat !== "All_Item") {
      if (String(cat).startsWith('tag__')) {
        const tagName = String(cat).replace('tag__', '').trim().toLowerCase();
        desktopItemList = desktopItemList.filter(i =>
          Array.isArray(i.tag) && i.tag.some(t => typeof t === 'string' && t.trim().toLowerCase() === tagName)
        );
      } else {
        const isCatId = (props.allCategoryList || []).some(c => String(c.category_id) === String(cat));
        if (isCatId) {
          desktopItemList = desktopItemList.filter(i => String(i.category_id) === String(cat));
        }
      }
    }
    return desktopItemList.filter(item => parseFloat(item?.item_variant?.[0]?.plu) >= 0);
  };

  return (
    <>
      <ItemModifier
        style={{ minWidth: "20rem" }}
        {...props}
        {...{
          modifierPopup,
          setModifierPopup,
          selectedItem,
          setSelectedItem,
          allitem,
          itemVerriantList,
          addonList,
          currency,
        }}
      />
      <Repeatation
        {...props}
        {...{
          isRepeatation,
          setIsRepeatation,
          selectedItem,
          setSelectedItem,
          setModifierPopup,
          action,
        }}
      />

      {!isDesktop && (
        <Fab
          ref={categoryMenuAnchorRef}
          size="medium"
          style={{
            position: "fixed",
            bottom: getFabBottom(),
            height: "70px",
            width: "70px",
            right: getFabRight(),
            background: primaryColor || BACKGROUND_COLOR,
            color: "white",
            zIndex: 1002,
            fontSize: "12px",
            fontWeight: "bold",
          }}
          onClick={handleCategoryMenuToggle}
        >
          <div style={{ lineHeight: "14px", fontSize: "14px" }}>
            {categoryMenuOpen ? (
              <ClearIcon style={{ fontSize: "30px" }} />
            ) : (
              <>
                {storeInfo?.store_industry == "F&B" ?
                  <RestaurantMenuIcon style={{ fontSize: "20px" }} /> : ""}
                <div style={{ fontFamily: "satoshi", fontWeight: "400" }}>
                  Menu
                </div>
              </>
            )}
          </div>
        </Fab>
      )}

      {!isDesktop && (
        <Backdrop
          open={categoryMenuOpen}
          style={{ zIndex: 1000, touchAction: "none", backgroundColor: "rgba(0,0,0,0.4)" }}
          onClick={handleCategoryMenuClose}
        />
      )}
      {!isDesktop && (
        <Popper
          open={categoryMenuOpen}
          anchorEl={categoryMenuAnchorRef.current}
          placement="top-start"
          style={{ zIndex: 1001 }}
        >
        <ClickAwayListener onClickAway={handleCategoryMenuClose}>
          <Paper
            style={{
              maxHeight: "300px",
              overflow: "auto",
              WebkitOverflowScrolling: "touch",
              overscrollBehavior: "none",
              minWidth: "280px",
              width: "320px",
              boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
              borderRadius: "12px",
            }}
          >
            <List dense style={{ padding: "8px 0" }}>
              {/* Tag virtual categories at top of mobile popup */}
              {(props.tagCategories || []).map(tag => {
                const tagName = tag.category_name;
                const tagItems = (allitem || []).filter(i => Array.isArray(i.tag) && i.tag.includes(tagName));
                if (tagItems.length === 0) return null;
                return (
                  <ListItem
                    key={tag.category_id}
                    button
                    onClick={() => handleCategoryClick(tag.category_id)}
                    style={{
                      borderBottom: "1px solid #f0f0f0",
                      padding: "12px 20px",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <div style={{ flex: 1, display: "flex", alignItems: "center", gap: "6px" }}>
                      <span style={{ fontSize: "14px" }}>⭐</span>
                      <Typography style={{ fontSize: "15px", fontWeight: "600", color: "black" }}>
                        {tagName}
                      </Typography>
                    </div>
                    <div style={{ color: "black", borderRadius: "12px", padding: "4px 8px", fontSize: "15px", fontWeight: "500", minWidth: "24px", textAlign: "center" }}>
                      {tagItems.length}
                    </div>
                  </ListItem>
                );
              })}
              {sortedCategories.map(([categoryId, categoryData]) => {
                const categoryName = getCategoryName(categoryId);

                // Only render if category name is valid
                if (categoryName === "Unknown Category") return null;

                const activeStoreId = appliedfilters?.selected_store?.store_id || storeInfo?.store_id;
                const originalCategoryItems = (allitem || []).filter((item) =>
                  String(item.category_id) === String(categoryId) &&
                  String(item.store_id) === String(activeStoreId) &&
                  parseFloat(item?.item_variant?.[0]?.plu) >= 0
                );
                const allOutOfStock = originalCategoryItems.length > 0 && originalCategoryItems.every(item => item.is_stock === false);

                return (
                  <ListItem
                    key={categoryId}
                    button
                    onClick={() => handleCategoryClick(categoryId)}
                    style={{
                      borderBottom: "1px solid #f0f0f0",
                      padding: "12px 20px",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      transition: "background-color 0.2s ease",
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = "#f8f8f8";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = "transparent";
                    }}
                  >
                    <div style={{ flex: 1, display: "flex", alignItems: "center", gap: "6px" }}>
                      <Typography
                        style={{
                          fontSize: "15px",
                          fontWeight: "500",
                          textTransform: "capitalize",
                          color: "black",
                          lineHeight: "1.2",
                        }}
                      >
                        {categoryName}
                      </Typography>
                      {allOutOfStock && (
                        <span style={{
                          fontSize: "10px",
                          backgroundColor: "white",
                          color: "#d32f2f",
                          border: "1px solid #d32f2f",
                          padding: "2px 6px",
                          borderRadius: "0.6rem",
                          fontWeight: "700",
                          textTransform: "uppercase",
                          // boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.16)",
                          whiteSpace: "nowrap"
                        }}>
                          Out of Stock
                        </span>
                      )}
                    </div>
                    <div
                      style={{
                        color: "black",
                        borderRadius: "12px",
                        padding: "4px 8px",
                        fontSize: "15px",
                        fontWeight: "500",
                        minWidth: "24px",
                        textAlign: "center",
                      }}
                    >
                      {categoryData.items.length}
                    </div>
                  </ListItem>
                );
              })}
            </List>
          </Paper>
        </ClickAwayListener>
      </Popper>
      )}

      <Grid
        container
        xs={12}
        sm={12}
        md={12}
        lg={12}
        style={{
          marginTop: "1rem",
          display: "flex",
          justifyContent: "center",
        }}
      >
        {props.isDesktop ? (
          getDesktopItems().length > 0 ? (
            <Grid container spacing={3} style={{ width: "100%", paddingBottom: (addedItems?.length > 0) ? "95px" : "24px" }}>
              {getDesktopItems()
                .sort((a, b) => selectedfilter ? 0 : a.sequence_no - b.sequence_no)
                .map((item, index) => (
                <Grid item xs={12} sm={6} md={6} lg={4} key={index}>
                  {renderDesktopItemCard(item, index)}
                </Grid>
              ))}
            </Grid>
          ) : (
            <Grid
              style={{
                display: "flex",
                height: "50vh",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                width: "100%"
              }}
            >
              <Typography style={{ marginBottom: "8px", fontSize: "18px", color: "#666" }}>
                Item Not Found
              </Typography>
              <Typography style={{ fontSize: "14px", color: "#999" }}>
                Please modify your search.
              </Typography>
            </Grid>
          )
        ) : sortedCategories.length ? (
          <div style={{ width: "100%", maxWidth: "800px", paddingBottom: (addedItems?.length > 0) ? "95px" : "24px" }}>
            {sortedCategories.map(
              ([categoryId, categoryData], categoryIndex) => {
                const categoryName = getCategoryName(categoryId);
                const activeStoreId = appliedfilters?.selected_store?.store_id || storeInfo?.store_id;
                const originalCategoryItems = (allitem || []).filter((item) =>
                  String(item.category_id) === String(categoryId) &&
                  String(item.store_id) === String(activeStoreId) &&
                  parseFloat(item?.item_variant?.[0]?.plu) >= 0
                );
                const allOutOfStock = originalCategoryItems.length > 0 && originalCategoryItems.every(item => item.is_stock === false);

                return (
                  <div
                    key={categoryId}
                    style={{
                      borderBottom: "3px solid #f0f0f0",
                    }}
                  >
                    <div
                      ref={(el) => (categoryRefs.current[categoryId] = el)}
                      style={{
                        textAlign: "left",
                        padding: "12px 0 8px 12px",
                        marginTop: categoryIndex > 0 ? "16px" : "0",
                      }}
                    >
                      <Typography
                        variant="h5"
                        style={{
                          fontWeight: "700",
                          color: "#333",
                          textTransform: "capitalize",
                          fontSize: "22px",
                          letterSpacing: "0.5px",
                          display: "flex",
                          alignItems: "center"
                        }}
                      >
                        {categoryName}
                        {allOutOfStock && (
                           <span style={{
                             fontSize: "12px",
                             backgroundColor: "white",
                             color: "#d32f2f",
                             border: "1px solid #d32f2f",
                             padding: "4px 10px",
                             borderRadius: "0.6rem",
                             marginLeft: "10px",
                             fontWeight: "700",
                             textTransform: "uppercase",
                            //  boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.16)"
                           }}>
                             Out of Stock
                           </span>
                         )}
                      </Typography>
                    </div>

                    {categoryData.items
                      ?.slice() // clone array to avoid mutating the original
                      .sort((a, b) => selectedfilter ? 0 : a.sequence_no - b.sequence_no)
                      .map((item, itemIndex) => (
                        renderItemCard(item, `${categoryId}-${itemIndex}`)
                      ))
                    }

                  </div>
                );
              }
            )}
            <div
              style={{
                textAlign: "left",
                padding: "0px 12px",
                paddingBottom: "24px",
              }}
            >
              {" "}
              <Box mt={2}>
                <Typography variant="h6">{storeInfo.store_name}</Typography>
              </Box>
              <Box mt={1}>
                <Typography style={{ fontWeight: "600" }} variant="body2">
                  {storeInfo.store_ad1},&nbsp;{storeInfo.store_city},&nbsp;
                  {storeInfo.store_state}&nbsp;-{storeInfo.store_zip}
                </Typography>
              </Box>
              <Box mt={1}>
                {storeFssai ? (
                  <>
                    <img style={{ width: "120px", height: "auto", display: "block", marginTop: "8px", marginBottom: "4px" }} src={fssaiimage} alt="FSSAI Logo" />
                    <Typography variant="subtitle1" style={{ fontSize: "14px", color: "#333", marginTop: "4px" }}>
                      License No. - {storeFssai}
                    </Typography>
                  </>
                ) : ""}
                <div style={{ margin: "10px 0px 30px 0px" }}>
                  <Typography variant="subtitle2">
                    <span style={{ fontSize: "0.8rem" }}> Powered By</span>
                    &nbsp;&nbsp;
                  </Typography>
                  <img alt="Logo" width="30%" src={CyntraLogo} />
                </div>
              </Box>
            </div>
          </div>
        ) : (
          <Grid
            style={{
              display: "flex",
              height: "50vh",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            <Typography
              style={{ marginBottom: "8px", fontSize: "18px", color: "#666" }}
            >
              Item Not Found
            </Typography>
            <Typography style={{ fontSize: "14px", color: "#999" }}>
              Please modify your search.
            </Typography>
          </Grid>
        )}
      </Grid>
    </>
  );
};

export default Items;